import React from "react";
import Field from "./Field";
import { controlClasses } from "./control";

export default function TextField({
  label,
  size = "sm",
  required,
  note,
  info,
  hint,
  wrapperClassName,
  className,
  type = "text",
  disabled,
  ...rest
}) {
  return (
    <Field
      label={label}
      required={required}
      note={note}
      info={info}
      hint={hint}
      dimmed={disabled}
      className={wrapperClassName}
    >
      <input
        type={type}
        disabled={disabled}
        className={controlClasses(size, className)}
        {...rest}
      />
    </Field>
  );
}
